import { render, staticRenderFns } from "./hotshop.vue?vue&type=template&id=51962ec5&scoped=true"
import script from "./hotshop.vue?vue&type=script&lang=js"
export * from "./hotshop.vue?vue&type=script&lang=js"
import style0 from "./hotshop.vue?vue&type=style&index=0&id=51962ec5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51962ec5",
  null
  
)

export default component.exports